import React from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { isNoIndexPath, NO_INDEX_ROBOTS } from "../../../utils/helpers/is-no-index-path";

const NoIndexMeta = () => {
    const { pathname = "" } = useLocation();
    if (!isNoIndexPath(pathname)) return null;
    return (
        <Helmet>
            <meta name="robots" content={NO_INDEX_ROBOTS} />
        </Helmet>
    );
};

export default NoIndexMeta;
